<style lang="scss" scoped="">
.el-form .el-select {
  display: block;
}

.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}
</style>
<template>
  <div class="content-part">
    <div class="content-right min-gutter">
      <h3 class="clearfix">修改单据基础信息</h3>
    <div slot="content" style="padding-left: 30px;padding-right: 30px">
      <el-row style="margin-bottom:0">
        <el-col :span="12">
          <oms-row label="业务单据号" :span="6" v-show="currentOrder.objectNo">{{ currentOrder.objectNo }}</oms-row>
          <oms-row label="业务类型" :span="6"> {{ filterBizType(currentOrder.bizType) }}</oms-row>
          <oms-row label="来源单位" :span="6">{{ currentOrder.sourceOrgName }}</oms-row>
          <oms-row label='物流方式' :span="6" v-show="currentOrder.transportationMeans">
            {{ currentOrder.transportationMeans }}
          </oms-row>
          <oms-row label='运输条件' :span="6" v-show="currentOrder.logisticsMode">{{ currentOrder.logisticsMode }}
          </oms-row>
          <oms-row label='签收时间' :span="6" v-show="currentOrder.handoverTime">{{ currentOrder.handoverTime | time }}
          </oms-row>
          <oms-row label='签收人' :span="6" v-show="currentOrder.handoverPerson">{{ currentOrder.handoverPerson }}
          </oms-row>
          <oms-row label='签收单位' :span="6" v-show="currentOrder.handoverOrg">{{ currentOrder.handoverOrg }}</oms-row>
          <oms-row label='上传人' :span="6" v-show="currentOrder.createdBy">{{ currentOrder.createdBy }}</oms-row>
          <oms-row label='上传单位' :span="6" v-show="currentOrder.uploadOrgName">{{ currentOrder.uploadOrgName }}
          </oms-row>
          <oms-row label="上传时间" :span="6" v-show="currentOrder.createTime">{{ currentOrder.createTime | time }}
          </oms-row>
        </el-col>
        <el-col :span="12">
          <oms-row label="作业号" :span="7" v-show="currentOrder.taskId"> {{ currentOrder.taskId }}</oms-row>
          <oms-row label="去向单位" :span="7">
            {{ currentOrder.directionOrgName }}
          </oms-row>
          <oms-row label="业务时间" :span="7">{{ currentOrder.operateTime | time }}</oms-row>
          <oms-row label="创建时间" :span="7">{{ currentOrder.createTime | time }}</oms-row>
          <oms-row label='温度是否合格' :span="7" v-show="typeof currentOrder.temperatureFlag === 'boolean'">
            <span v-show="currentOrder.temperatureFlag">合格</span>
            <span v-show="!currentOrder.temperatureFlag">不合格</span>
          </oms-row>
          <oms-row label='操作人' :span="7" v-show="currentOrder.createdBy">{{ currentOrder.createdBy }}</oms-row>
          <oms-row label='操作单位' :span="7">{{ currentOrder.systemOrg }}</oms-row>

          <oms-row :is-show="true" label="状态" :span="7">
            <el-tag type="warning" v-show="currentOrder.status === '0'">解析中</el-tag>
            <el-tag type="success" v-show="currentOrder.status === '1'">正常</el-tag>
            <el-tag type="danger" v-show="currentOrder.status === '2'">异常</el-tag>
          </oms-row>
        </el-col>
      </el-row>
      <el-table :data="currentOrder.detailList" style="width: 100%" class="mt-10 header-list">
        <el-table-column prop="goodsName" label="货品名称" min-width="150"/>
        <el-table-column prop="specification" label="规格" min-width="120"/>
        <el-table-column prop="batchNumber" label="批号"/>
        <el-table-column prop="reviewCodeCount" label="件数" min-width="50"/>
        <el-table-column prop="count" label="数量" min-width="50"/>
      </el-table>
    </div>
    <div style="padding-top: 20px;padding-left: 30px;padding-right: 30px">
      <el-form :model="form" :rules="rules" @submit.prevent="onSubmit('accountform')" label-width="110px"
               onsubmit="return false" ref="accountform">
        <el-form-item label="业务单据号" prop="objectNo">
          <el-input placeholder="请输入业务单据号" v-model="form.objectNo" :maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="来源单位" prop="sourceOrgId">
          <el-select filterable remote placeholder="请输入名称/拼音首字母缩写/系统代码搜索来源单位" :remote-method="queryUpAllFactory"
                     :clearable="true" v-model="form.sourceOrgId" popperClass="good-selects"
                     @change="setSourceOrgName"
                     @click.native="queryUpAllFactory">
            <el-option :value="item.id" :key="item.id" :label="item.name" v-for="item in allOrgList">
              <div style="overflow: hidden">
                <span class="pull-left" style="clear: right">{{ item.name }}</span>
              </div>
              <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{ item.manufacturerCode }}
                      </span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="去向单位" prop="directionOrgId">
          <el-select filterable remote placeholder="请输入名称/拼音首字母缩写/系统代码搜索去向单位" :remote-method="queryDownAllFactory"
                     :clearable="true" v-model="form.directionOrgId" popperClass="good-selects"
                     @change="setDirectionOrgName"
                     @click.native="queryDownAllFactory">
            <el-option :value="item.id" :key="item.id" :label="item.name" v-for="item in downOrgList">
              <div style="overflow: hidden">
                <span class="pull-left" style="clear: right">{{ item.name }}</span>
              </div>
              <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{ item.manufacturerCode }}
                      </span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="100px">
          <el-button :disabled="doing" @click="onSubmit('accountform')" native-type="submit" type="primary">保存
          </el-button>
          <el-button @click="doClose">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    </div>
  </div>
</template>

<script>
import {BaseInfo, http} from '@/resources';
import MethodsMix from '@/mixins/methodsMinix';

export default {
  name: 'editForm',
  mixins: [MethodsMix],
  props: {
    currentOrder: {},
    filterBizType: Function
  },
  data: function () {
    return {
      form: {
        id: '',
        objectNo: '',
        sourceOrgId: '',
        sourceOrgName: '',
        directionOrgId: '',
        directionOrgName: ''
      },
      rules: {
        objectNo: [
          {required: true, message: '请输入业务单据号', trigger: 'blur'}
        ],
        sourceOrgId: [
          {required: true, message: '请选择来源单位', trigger: 'blur'}
        ],
        directionOrgId: [
          {required: true, message: '请选择去向单位', trigger: 'blur'}
        ]
      },
      doing: false,
      allOrgList: [],
      downOrgList: []
    };
  },
  watch: {
    currentOrder: function () {
      if (this.currentOrder.objectNo) {
        this.form.objectNo = this.currentOrder.objectNo;
      }
      if (this.currentOrder.sourceOrgName) {
        this.form.sourceOrgId = this.currentOrder.sourceOrgId;
        this.form.sourceOrgName = this.currentOrder.sourceOrgName;
        this.allOrgList.push({"id": this.currentOrder.sourceOrgId, "name": this.currentOrder.sourceOrgName});
        // this.queryUpAllFactory(this.currentOrder.sourceOrgName);
      }
      if (this.currentOrder.directionOrgName) {
        this.form.directionOrgId = this.currentOrder.directionOrgId;
        this.form.directionOrgName = this.currentOrder.directionOrgName;
        this.downOrgList.push({"id": this.currentOrder.directionOrgId, "name": this.currentOrder.directionOrgName});
        // this.queryDownAllFactory(this.currentOrder.directionOrgName);
      }
      this.form.id = this.currentOrder.id;
    }
  },
  methods: {
    setSourceOrgName: function () {
      if (!this.form.sourceOrgId) return;
      let sourceOrg = this.allOrgList.filter(f => f.id === this.form.sourceOrgId)[0];
      if (sourceOrg) {
        this.form.sourceOrgName = sourceOrg.name;
      }
    },
    setDirectionOrgName: function () {
      if (!this.form.directionOrgId) return;
      let directionOrg = this.downOrgList.filter(f => f.id === this.form.directionOrgId)[0];
      if (directionOrg) {
        this.form.directionOrgName = directionOrg.name;
      }
    },
    queryUpAllFactory(query) { // 查询DHS上游单位
      let params = {
        keyWord: query
      };
      BaseInfo.query(params).then(res => {
        this.allOrgList = res.data.list;
      });
    },
    queryDownAllFactory(query) { // 查询DHS下游单位
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query};
      } else if (typeof query === 'object') {
        params = query;
      }
      BaseInfo.query(params).then(res => {
        this.downOrgList = res.data.list;
      });
    },
    onSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        this.doing = true;
        http.put(`/code-biz`, this.form).then(() => {
          this.$notify.success({
            duration: 2000,
            title: '成功',
            message: '修改单据基础信息成功'
          });
          this.doing = false;
          this.$emit('change');
          this.$emit('close');
        }).catch(error => {
          this.doing = false;
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '修改单据基础信息失败'
          });
        });
      });
    },
    doClose: function () {
      this.$emit('close');
    }
  }
};
</script>
